import Link from "@components/shared/linkNoPrefetch";
import styles from "./style.module.scss";
import Image from "next/legacy/image";
import { GQLOffers, GQLUrls } from "@gql/types/gql";
import { useRouter } from "next/router";
import OfferLinks from "@components/shared/offerLinks";
import ArrowRight from "@components/shared/bestBuyers/icons/ArrowRight";
import { useQuery } from "@tanstack/react-query";
import { PLACE_HOLDER_IMAGE_PATH, resolveURL } from "@lib/sharedUtils";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import Discount from "@components/category/bestOverAll/icons/Discount";

export default function BuyerItemHeader({
    buyer,
    index,
    categoryId,
}: {
    buyer: GQLOffers;
    index: number;
    categoryId: number;
}) {
    const { query } = useRouter();
    const id = query.id;
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    const scoreMessage = buyer?.attributes?.find(
        (attr) => attr?.baseAttribute?.name === "scoreMsg",
    )?.value;
    const scoreValue = buyer?.attributes?.find(
        (attr) => attr?.baseAttribute?.name === "scoreValue",
    )?.value;
    const discountValue = buyer?.attributes?.find(
        (attr) => attr?.baseAttribute?.name === "discountValue",
    )?.value;
    return (
        <>
            <div
                id={buyer.slug as string}
                className="flex justify-between  w-full "
            >
                <div className="flex items-center  gap-4">
                    <div
                        className={`font-extrabold lg:text-6xl text-2xl leading-[52px] lg:leading-[90x] ${styles["orderColor"]} border-r lg:pr-6 pr-4`}
                    >
                        {index + 1}
                    </div>

                    <h2
                        className=" font-extrabold text-xl lg:text-2xl  pr-2 "
                        itemProp="name"
                    >
                        <Link
                            href={`${resolveURL(buyer.url as GQLUrls)}`}
                            className={`${styles.titleColor} cursor-pointer`}
                        >
                            {buyer?.summaryTitle ?? buyer?.title ?? ""}
                        </Link>
                    </h2>
                </div>
                <div className="flex items-center gap-3">
                    {scoreMessage ? (
                        <div className=" lg:text-2xl text-sm lg:leading-9  leading-5 ">
                            {scoreMessage}
                        </div>
                    ) : (
                        <></>
                    )}
                    {scoreValue ? (
                        <div
                            className={`${styles["numberRateColors"]} font-extrabold lg:text-2xl text-sm lg:leading-9 leading-5 p-2 rounded-lg`}
                        >
                            {scoreValue}
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            </div>

            <div
                className={`lg:mt-4 mt-6 bg-[#F6F8FB] ${styles.offerListImage}`}
            >
                {buyer?.mainImage?.fullPath ? (
                    <div className={` relative w-full ${styles.mainImage}`}>
                        <Image
                            src={buyer?.mainImage?.fullPath}
                            alt={buyer?.title as string}
                            width={844}
                            height={538}
                            itemProp="image"
                            className="block w-full"
                            sizes="(max-width: 768px) 100vw,
                            (max-width: 1200px) 50vw,
                            60vw"
                        />
                    </div>
                ) : (
                    <>
                        <img
                            src={PLACE_HOLDER_IMAGE_PATH}
                            width={844}
                            height={538}
                            alt="category image"
                        />
                    </>
                )}
                <div
                    className={` flex items-center justify-between py-6  px-4  `}
                >
                    <div className={`${styles["buyerDetailsShow"]}`}>
                        <Link href={`${resolveURL(buyer.url as GQLUrls)}`}>
                            <span className="flex items-center cursor-pointer  max-w-[400px]">
                                <span
                                    className={`${styles["reviewColor"]}   text-lg  leading-7 `}
                                >
                                    {`${translate(
                                        translations,
                                        "several_general_readWord",
                                    )} ${buyer.name as string} ${translate(
                                        translations,
                                        "several_general_reviewWord",
                                    )}`}

                                    <ArrowRight />
                                </span>
                            </span>
                        </Link>
                    </div>
                    <div className="sm:w-[28%]  w-full">
                        <OfferLinks
                            vendor={buyer}
                            categoryId={parseInt(id as string) ?? categoryId}
                            classNameButton={styles["buttonStyle"]}
                            vendorShow={true}
                        />
                        {discountValue && (
                            <span className="flex justify-center items-center font-bold gap-2  text-[#E85951]">
                                <Discount />{" "}
                                {translate(
                                    translations,
                                    "several_general-DiscountWord",
                                )}{" "}
                                {`${discountValue}%`}
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
